
/**
 * @class
 * @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const amountText = this.querySelector('.free-shipping--text span');
      const total = parseInt(this.dataset.cartTotal, 10) || 0;

      // Thresholds in cents
      const milestone1 = 8000;   // $80 - Free Shipping
      const milestone2 = 11000;  // $110 - Free Drink Pocket Jacket
      const milestone3 = 15000;  // $150 - $10 OFF

      this.remainingText = this.querySelector('.free-shipping--message');
      this.fullText = this.querySelector('.free-shipping--text-full');

      // Calculate progress, capped at 100%
      let percentage = total / milestone3;

      if (percentage > 1) percentage = 1;
      if (percentage < 0) percentage = 0;

      let remaining = 0;
      let message = '';
      let showUnlocked = false;

      const unlockedMessage =
        'You’ve unlocked FREE shipping, a FREE Drink Pocket Jacket, and $10 off.';

      // Check milestones in descending order
      if (total >= milestone3) {
        showUnlocked = true;
      } else if (total >= milestone2) {
        remaining = milestone3 - total;
        message = 'more to unlock $10 off your order';
      } else if (total >= milestone1) {
        remaining = milestone2 - total;
        message = 'more to unlock FREE Drink Pocket Jacket';
      } else {
        remaining = milestone1 - total;
        message = 'more to unlock FREE shipping';
      }

      const format =
        window.theme.settings.money_with_currency_format || '${{amount}}';

      // Update remaining amount
      if (amountText) {
        if (showUnlocked) {
          amountText.innerHTML = '';
        } else {
          amountText.innerHTML = formatMoney(remaining, format);
        }
      }

      // Update message
      if (this.remainingText && this.fullText) {
        if (showUnlocked) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
          this.fullText.textContent = unlockedMessage;
        } else {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
          this.remainingText.textContent = message;
        }
      }

      // Update progress bar
      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
